import { useTranslation } from 'react-i18next';
import { useApp } from '@/context/AppContext';

const STATUS_TO_KEY = {
  local:     { className: 'local',     textKey: 'sync.local',     titleKey: 'sync.localTitle',   dot: false },
  connected: { className: 'connected', textKey: 'sync.cloud',     titleKey: 'sync.cloudTitle',   dot: true  },
  syncing:   { className: 'syncing',   textKey: 'sync.syncing',   titleKey: 'sync.syncingTitle', dot: true  },
  error:     { className: 'error',     textKey: 'sync.error',     titleKey: 'sync.errorTitle',   dot: true  },
};

export default function SyncIndicator({ compact = false }) {
  const { t } = useTranslation('painterops');
  const { syncStatus, retrySync } = useApp();
  const cfg = STATUS_TO_KEY[syncStatus] || STATUS_TO_KEY.local;

  const handleClick = () => {
    if (syncStatus === 'error') retrySync();
  };

  return (
    <button
      type="button"
      className={`sync-pill ${cfg.className}${syncStatus === 'error' ? ' clickable' : ''}`}
      title={t(cfg.titleKey)}
      onClick={handleClick}
      style={compact ? { padding: '3px 8px', fontSize: 10 } : undefined}
    >
      {cfg.dot && <span className="sync-dot" />}
      {t(cfg.textKey)}
    </button>
  );
}
